export const state = {
  helpInfoList: [
    {
      defineId: 'test',
      helpMsgTitle: 'test',
      helpMsgValue: 'test',
      updateDateTime: '20190303'
    },
    {
      helpMsgTitle: 'test2',
      helpMsgValue: 'test2',
      updateDateTime: '20190304'
    },
    {
      helpMsgTitle: 'test3',
      helpMsgValue: 'test3',
      updateDateTime: '20190305'
    }
  ],
  helpInfo: {
  },
  importantMsgTitle: null,
  importantMsgValue: null,
  privacyPolicyPageUri: null,
  locationInfoToken: null,
  adminMailAddress: null,
  mailInfo: {
    sendTarget: '',
    mailTitle: '',
    mailContent: ''
  }
}
export const mutations = {
  inputUpdateDefineInfo (state, payload) {
    state[payload.name] = payload.value
  },
  inputUpdateHelpMsg (state, payload) {
    state.helpInfo[payload.name] = payload.value
  },
  inputUpdateMail (state, payload) {
    state.mailInfo[payload.name] = payload.value.replace(/[\r\n]/g, '<br />')
  },
  setHelpInfos (state, response) {
    if (response.data['data'] == null) {
      response.data['data'] = []
    }
    state.helpInfoList = response.data['data']
  },
  cleareDefineInfo (state) {
    // null -> 更新対象としない, "" -> 必須チェック（管理者メールアドレス）
    state.importantMsgTitle = null
    state.importantMsgValue = null
    state.privacyPolicyPageUri = null
    state.locationInfoToken = null
    state.adminMailAddress = null
  },
  cleareHelpInfo (state) {
    state.helpInfo = {}
  },
  cleareMailInfo (state) {
    state.mailInfo = {}
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/companiesCommonOptionModules/companiesCommonOptionMutation.js